var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label fw-bolder mb-0",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.titulo))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }